import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CryptoState } from '../CryptoContext';
import { SingleCoin } from '../config/api';
import {
  Button,
  LinearProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import CoinInfo from '../components/CoinInfo';
import ReactHtmlParser from 'react-html-parser';
import { numberWithCommas } from '../helpers';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  sidebar: {
    width: '30%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 25,
    borderRight: '2px solid grey',
  },
  coinImage: {
    marginBottom: 20,
  },
  heading: {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  description: {
    width: '100%',
    padding: 25,
    paddingBottom: 15,
    paddingTop: 0,
    textAlign: 'justify',
  },
  marketData: {
    alignSelf: 'start',
    padding: 25,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  rank: {
    marginLeft: 10,
  },
  chart: {},
}));

function Coin() {
  const classes = useStyles();
  const { id } = useParams();
  const [coin, setCoin] = useState();

  const { currency, symbol, user, watchlist, setAlert } = CryptoState();

  const fetchCoin = async () => {
    const { data } = await axios.get(SingleCoin(id));
    setCoin(data);
  };

  useEffect(() => {
    fetchCoin();
  }, []);

  if (!coin) {
    return <LinearProgress style={{ backgroundColor: 'gold' }} />;
  }

  const inWatchList = watchlist.includes(coin?.id);

  const addToWatchlist = async () => {
    const coinRef = doc(db, 'watchlist', user.uid);

    try {
      await setDoc(coinRef, {
        coins: watchlist ? [...watchlist, coin.id] : [coin?.id],
      });
      setAlert({
        open: true,
        message: `${coin.name} added to the Watchlist`,
        type: 'success',
      });
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: 'error',
      });
    }
  };

  const removeFromWatchlist = async () => {
    const coinRef = doc(db, 'watchlist', user.uid);

    try {
      await setDoc(
        coinRef,
        {
          coins: watchlist.filter((watchId) => watchId !== coin?.id),
        },
        { merge: true }
      );
      setAlert({
        open: true,
        message: `${coin.name} removed from the Watchlist`,
        type: 'success',
      });
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: 'error',
      });
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.sidebar}>
        <img
          src={coin?.image.large}
          alt='coin name'
          height='200'
          className={classes.coinImage}
        />
        <Typography variant='h3' className={classes.heading}>
          {coin?.name}
        </Typography>
        <Typography className={classes.description} variant='subtitle1'>
          {ReactHtmlParser(coin?.description.en.split('. ')[0])}.
        </Typography>
        <div className={classes.marketData}>
          <span style={{ display: 'flex', marginBottom: 15 }}>
            <Typography variant='h5'>Rank:</Typography>
            <Typography variant='h5' className={classes.rank}>
              {coin?.market_cap_rank}
            </Typography>
          </span>
          <span style={{ display: 'flex', marginBottom: 15 }}>
            <Typography variant='h5'>Current Price:</Typography>
            <Typography variant='h5' className={classes.rank}>
              {symbol}
              {numberWithCommas(
                coin?.market_data.current_price[currency.toLowerCase()]
              )}
            </Typography>
          </span>
          <span style={{ display: 'flex', marginBottom: 15 }}>
            <Typography variant='h5'>Market Cap:</Typography>
            <Typography variant='h5' className={classes.rank}>
              {symbol}
              {numberWithCommas(
                coin?.market_data.market_cap[currency.toLowerCase()]
                  .toString()
                  .slice(0, -6)
              )}
            </Typography>
          </span>
          {user && (
            <Button
              variant='outlined'
              style={{
                width: '100%',
                height: 40,
                backgroundColor: inWatchList ? '#ff0000' : '#eebc1d',
              }}
              onClick={inWatchList ? removeFromWatchlist : addToWatchlist}
            >
              {inWatchList ? 'Remove from Watchlist' : 'Add to Watchlist'}
            </Button>
          )}
        </div>
      </div>
      <CoinInfo coin={coin} />
    </div>
  );
}

export default Coin;
